module.exports = __webpack_public_path__ + "img/clock.3ce578c7.svg";